export default __webpack_public_path__ + "static/0099-cdee0c3a0fa2038daeff560e7b8d02f1.png";